function toggleDropdown(contentId, iconId) {
    const content = document.getElementById(contentId);
    const icon = document.getElementById(iconId);

    const circleMap = {
        'colorDropdownContent': 'colorCircle'
        , 'dimensionsDropdownContent': 'dimensionsCircle'
        , 'installationDropdownContent': 'installationCircle'
    };

    const circleId = circleMap[contentId];
    const circle = document.getElementById(circleId);

    if (content.classList.contains('hidden')) {
        content.classList.remove('hidden');
        icon.style.transform = 'rotate(180deg)';

        if (circle) {
            circle.classList.add('active');
        }
    } else {
        content.classList.add('hidden');
        icon.style.transform = 'rotate(0deg)';

        if (circle) {
            circle.classList.remove('active');
        }
    }
}

function closeAllDropdowns() {
    const dropdowns = [
        'colorDropdownContent'
        , 'dimensionsDropdownContent'
        , 'installationDropdownContent'
    ];
    const icons = [
        'colorDropdownIcon'
        , 'dimensionsDropdownIcon'
        , 'installationDropdownIcon'
    ];
    const circles = [
        'colorCircle'
        , 'dimensionsCircle'
        , 'installationCircle'
    ];

    dropdowns.forEach((id, index) => {
        const content = document.getElementById(id);
        const icon = document.getElementById(icons[index]);
        const circle = document.getElementById(circles[index]);

        if (content && icon) {
            content.classList.add('hidden');
            icon.style.transform = 'rotate(0deg)';

            if (circle) {
                circle.classList.remove('active');
            }
        }
    });
}

function selectColor(variantId, variantTitle, variantImage) {
    window.location.href = '?variant=' + variantId;
}

window.toggleDropdown = toggleDropdown;
window.closeAllDropdowns = closeAllDropdowns;
window.selectColor = selectColor;

document.querySelectorAll('.configurator__label input, .configurator__label textarea')
    .forEach(el => {
        if (el.value) el.classList.add('filled');
        el.addEventListener('input', () =>
            el.classList.toggle('filled', el.value !== '')
        );
    });
